import { SensorType } from './Sensor';
// For Sensor filter
export var GenericSensorTypeFilter;
(function (GenericSensorTypeFilter) {
    GenericSensorTypeFilter["TEMPERATURE"] = "Temperature";
    GenericSensorTypeFilter["HUMIDITY"] = "Ambient";
    GenericSensorTypeFilter["ACCESS_STATUS"] = "Access";
})(GenericSensorTypeFilter || (GenericSensorTypeFilter = {}));
export const sensorTypeToGenericSensorTypeFilterMapping = {
    [SensorType.TEMPERATURE]: GenericSensorTypeFilter.TEMPERATURE,
    [SensorType.HUMIDITY]: GenericSensorTypeFilter.HUMIDITY,
    [SensorType.BINARY]: GenericSensorTypeFilter.ACCESS_STATUS,
};
// For Sensor filter in equipment tables
export var SensorTypeFilter;
(function (SensorTypeFilter) {
    SensorTypeFilter["TEMPERATURE"] = "Temperature";
    SensorTypeFilter["HUMIDITY"] = "Humidity";
    SensorTypeFilter["ACCESS_STATUS"] = "Access Status";
    SensorTypeFilter["ENERGY"] = "Energy";
})(SensorTypeFilter || (SensorTypeFilter = {}));
export var ScrollableColumnHeader;
(function (ScrollableColumnHeader) {
    ScrollableColumnHeader["TEMPERATURE"] = "Temperature";
    ScrollableColumnHeader["HUMIDITY"] = "Humidity";
    ScrollableColumnHeader["ACCESS_STATUS"] = "Access Status";
    ScrollableColumnHeader["ENERGY"] = "Energy";
    ScrollableColumnHeader["CONTROL_SCHEDULE"] = "Control Schedule";
})(ScrollableColumnHeader || (ScrollableColumnHeader = {}));
export const sensorTypeFilterToSensorTypeMapping = {
    [SensorTypeFilter.TEMPERATURE]: SensorType.TEMPERATURE,
    [SensorTypeFilter.HUMIDITY]: SensorType.HUMIDITY,
    [SensorTypeFilter.ACCESS_STATUS]: SensorType.BINARY,
};
export const sensorTypeToSensorTypeFilterMapping = {
    [SensorType.TEMPERATURE]: SensorTypeFilter.TEMPERATURE,
    [SensorType.HUMIDITY]: SensorTypeFilter.HUMIDITY,
    [SensorType.BINARY]: SensorTypeFilter.ACCESS_STATUS,
};
export const scrollableColumnHeaderToSensorTypeFilterMapping = {
    [ScrollableColumnHeader.TEMPERATURE]: SensorTypeFilter.TEMPERATURE,
    [ScrollableColumnHeader.HUMIDITY]: SensorTypeFilter.HUMIDITY,
    [ScrollableColumnHeader.ACCESS_STATUS]: SensorTypeFilter.ACCESS_STATUS,
    [ScrollableColumnHeader.ENERGY]: SensorTypeFilter.ENERGY,
};
export const sensorTypeToScrollableColumnHeaderMapping = {
    [SensorType.TEMPERATURE]: ScrollableColumnHeader.TEMPERATURE,
    [SensorType.HUMIDITY]: ScrollableColumnHeader.HUMIDITY,
    [SensorType.BINARY]: ScrollableColumnHeader.ACCESS_STATUS,
};
